export default {"src":"/_next/static/media/chevron-down.1fa07040.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};